var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuth0({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.598 219.534c81.954-13.469 146.22-77.719 159.673-159.672l6.609-39.875c1.219-7.75-5.063-14.516-12.89-13.953-62.391 4.812-121.188 25.531-153.72 38.812a42.042 42.042 0 00-26.094 38.907v125.984c0 7.422 6.61 13.047 13.938 11.828l12.484-2.03zM275.74 59.862c13.453 81.953 77.703 146.203 159.672 159.656l12.468 2.047c7.344 1.22 13.938-4.406 13.938-11.828V83.753c0-17.047-10.344-32.375-26.094-38.907-32.453-13.375-91.328-34-153.703-38.812-7.844-.578-14.203 6.203-12.891 13.937l6.61 39.89zM435.474 259.081c-81.953 13.453-146.219 77.719-159.672 159.672l-8.156 77.797c-.735 7.016 7.015 11.985 12.89 8.078 0 0 .078 0 .157-.078 51.375-34.672 168.64-125.422 180.219-238.781.578-5.547-4.407-10.11-9.86-9.22l-15.5 2.532h-.078zM236.24 418.722c-13.47-81.953-77.72-146.22-159.673-159.672l-16.719-2.781c-4.89-.813-9.296 3.265-8.812 8.25 11.016 114 129.906 205.328 181.688 239.984 5.39 3.594 12.484-.734 11.828-7.172l-8.235-78.687-.078.078z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth0);
export default __webpack_public_path__ + "static/media/Auth 0.ac936a8d07bb61181f422e611cec59c6.svg";
export { ForwardRef as ReactComponent };